import "reflect-metadata";
import {inject, injectable} from "inversify";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";
import {CancelTokenSource} from "axios";

@injectable()
export class InformReadInternalChatMessagesUseCase {
    private _repository: InternalChatRepository;

    constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
        this._repository = repository;
    }

    public call(internalChatId: string, cancelTokenSource?: CancelTokenSource): Promise<void> {
        return this._repository.informReadMessages(internalChatId, cancelTokenSource);
    }
}
